import { useTranslate, useTranslation } from '../../../modules/system/vue/i18n/useTranslation'
import { onMounted, ref } from 'vue'

export function useClvrTranslation(namespaces: string[] = ['clevehr']) {
    const $t = useTranslate()
    const translation = useTranslation()
    const translationLoading = ref<boolean>(true)

    onMounted(() => translation.i18next.loadNamespaces(namespaces).then(() => (translationLoading.value = false)))

    return {
        $t,
        translation,
        translationLoading,
    }
}
